import { ApiTypes, client } from '../client';

export const resendVerifyEmail = () => {
    return client.GET('/signup/step1', {});
};

export const updateGender = ({ gender, storyId }: ApiTypes.SignupUpdateGender) => {
    return client.POST('/signup/step2', { body: { gender, storyId } });
};

export const acceptAgreement = async ({ fullLegalName }: ApiTypes.SignupUpdateAgreement) => {
    return client.POST('/signup/step3', {
        body: {
            fullLegalName,
        },
    });
};

export async function getCheckDocumentsUrl(): Promise<string | undefined> {
    const { data } = await client.GET('/signup/step4', {});
    return data?.url;
}

export async function getCheckAgeUrl(): Promise<string | undefined> {
    const { data } = await client.GET('/signup/step6', {});
    return data?.url;
}

export function getVerificationStatus() {
    return client.GET('/signup/step5', {});
}

export function tryAgainVerification() {
    return client.POST('/signup/step5', { body: {} });
}

export function tryNewVerification() {
    return client.PATCH('/signup/step4', { body: {} });
}

export const verifyDocuments = async ({ selfieWithId, idPhoto, idPhotoBack }: ApiTypes.SignupUpdateDocuments) => {
    return client.POST('/signup/step4', {
        body: {
            selfieWithId,
            idPhoto,
            idPhotoBack,
        },
    });
};
